/* @generated */

// src/assets/pictogram/person-hide.tsx
import * as React from "react";
var PersonHidePictogram = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.172 53.941 3.341-3.342a16.826 16.826 0 0 1-2.501-2.857L13 47.725C10.323 43.86 9 38.63 9 32 9 15.85 16.85 8 33 8c8.451 0 14.63 2.15 18.6 6.513l2.998-2.998 2.667 2.666-42.427 42.427-2.666-2.667Zm5.6-6.713c.184.184.375.364.574.539L26.113 40H23a6 6 0 0 0-6 6v.382c.248.297.505.58.772.846Zm30.456-30.456c.184.184.364.375.539.574l-6.13 6.13C41.614 18.455 38.435 16 33 16c-6.73 0-10 3.761-10 11.5 0 3.768.775 6.593 2.348 8.5H23a9.998 9.998 0 0 0-8.764 5.181C13.438 38.704 13 35.677 13 32c0-7.487 1.82-12.276 4.772-15.228C20.725 13.82 25.512 12 33 12c7.487 0 12.276 1.82 15.228 4.772Zm-10.723 4.7c.732.842 1.439 2.49 1.492 5.644l-7.755 7.755c-1.454-.24-2.254-.777-2.747-1.344C27.735 32.653 27 30.905 27 27.5c0-3.405.734-5.152 1.495-6.027C29.158 20.71 30.377 20 33 20s3.842.71 4.505 1.473Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M22.546 54.557C25.53 55.52 29.011 56 33 56c6.789 0 12.111-1.387 16-4.195l.042-.03A16.782 16.782 0 0 0 53 47.725C55.677 43.86 57 38.63 57 32c0-3.989-.479-7.471-1.443-10.454l-3.258 3.258C52.755 26.868 53 29.252 53 32c0 3.677-.439 6.704-1.236 9.181A9.998 9.998 0 0 0 43 36h-1.897l-4 4H43a6 6 0 0 1 6 6v.382c-.248.297-.505.58-.772.846C45.275 50.18 40.488 52 33 52c-2.748 0-5.132-.245-7.196-.701l-3.258 3.258Z",
    fill: "currentColor"
  }
));
export {
  PersonHidePictogram
};
